import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { EnvironmentInterface } from '../interfaces';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  public getEnvironment(): EnvironmentInterface {
    return environment;
  }
}
